export default {
    get selectedVariant() {
        const {purchaseType} = this;

        if (!purchaseType) {
            return this.currentVariant;
        }

        if (purchaseType?.toLowerCase() !== "subscription") {
            return this.currentVariant;
        }

        return this.currentSubscriptionVariant;
    },

    get options_with_values() {
        const {product} = this;
        if (!product) {
            return [];
        }

        const options_with_values = product?.options_with_values;
        if (!options_with_values) {
            return [];
        }

        if (!options_with_values?.length) {
            return [];
        }

        return options_with_values;
    },

    get named_options() {
        const {options_with_values} = this;
        if (!options_with_values) {
            return {};
        }

        if (!options_with_values?.length) {
            return {};
        }

        return options_with_values?.reduce((named_options, option) => {
            const name = option?.name?.toLowerCase();
            if (!name) {
                return named_options;
            }

            const position = option?.position;
            if (!position) {
                return named_options;
            }

            return {
                ...named_options,
                [name]: `option${position}`,
            };
        }, {});
    },

    get subscription_product_option_mappings() {
        const {named_options} = this;
        if (!named_options) {
            return {};
        }

        const named_option_keys = Object.keys(named_options);
        if (!named_option_keys) {
            return {};
        }

        if (!named_option_keys?.length) {
            return {};
        }

        const product = this.product;
        if (!product) {
            return {};
        }

        const options_with_values = product?.options_with_values;
        if (!options_with_values) {
            return {};
        }

        if (!options_with_values?.length) {
            return {};
        }

        return options_with_values.reduce((subscription_product_option_mappings, option) => {
            const name = option?.name?.toLowerCase();
            if (!name) {
                return subscription_product_option_mappings;
            }

            const position = option?.position;
            if (!name) {
                return subscription_product_option_mappings;
            }

            if (!named_option_keys?.includes(name)) {
                return subscription_product_option_mappings;
            }

            const key = named_options[name];
            if (!key) {
                return subscription_product_option_mappings;
            }

            return {
                ...subscription_product_option_mappings,
                [key]: `option${position}`,
            };
        }, {});
    },

    get currentSubscriptionVariant() {
        const product = this.product;
        if (!product) {
            return false;
        }

        const {currentVariant} = this;
        if (!currentVariant) {
            return null;
        }

        const variants = product?.variants;
        if (!variants) {
            return null;
        }

        if (!variants?.length) {
            return null;
        }

        const {subscription_product_option_mappings} = this;
        if (!subscription_product_option_mappings) {
            return null;
        }

        const currentSubscriptionVariant = variants?.find((variant) => !Object?.keys(subscription_product_option_mappings)?.map((key) => {
            const subscription_variant_key = subscription_product_option_mappings[key];
            if (!subscription_variant_key) {
                return false;
            }

            return currentVariant[key] === variant[subscription_variant_key];
        })?.includes(false));

        if (!currentSubscriptionVariant) {
            return null;
        }

        return currentSubscriptionVariant;
    },

    get button_text() {
        if (this.isMembershipProduct) {
            if (this.membership_already_in_cart) {
                return 'Already in a bag';
            }

            if (this.isActiveSubscriber) {
                return 'You are active member';
            }

            return window.theme?.strings?.addToBag || 'Add to Bag';
        }

        const {currentVariant} = this;
        if (!currentVariant) {
            return window.theme?.strings?.unavailable || 'Unavailable';
        }

        const available = currentVariant?.available;
        if (!available) {
            return window.theme?.strings?.soldOut || 'Sold Out';
        }

        return window.theme?.strings?.addToBag || 'Add to Bag';
    },

    get mobile_button_text() {
        return this.button_text;
    },

    get buy_now_button_text() {
        return window.theme?.strings?.buyNow || 'Buy now';
    },

    get button_success_text() {
        return window.theme?.strings?.addedToBag || 'Added to Bag';
    },

    get current_discount_message() {
        const current_discount_levels = this.current_discount_levels;
        if (!current_discount_levels) {
            return "";
        }

        if (!current_discount_levels?.length) {
            return "";
        }

        const frequency = this.frequency;
        if (!frequency) {
            return "";
        }

        const {current_discount_level} = this;
        if (!current_discount_level) {
            return "";
        }

        let message;
        if (this.cart_total_lashes_quantity > 0) {
            message = current_discount_level?.messages?.next;
        } else {
            message = current_discount_level?.messages?.current;
        }
        if (!message) {
            return "";
        }

        const next_discount_level = current_discount_levels[this.current_discount_level_index + 1] || current_discount_levels[current_discount_levels.length - 1] || null;

        return message?.replaceAll(`{{ frequency }}`, frequency)
            ?.replaceAll(`{{ discount }}`, current_discount_level?.discount)
            ?.replaceAll(`{{ current_discount }}`, current_discount_level?.discount)
            ?.replaceAll("{{ min_value }}", current_discount_level?.min_value || "")
            ?.replaceAll("{{ max_value }}", current_discount_level?.max_value || "")
            ?.replaceAll("{{ next_discount }}", next_discount_level?.discount || "")
            ?.replaceAll("{{ next_min_value }}", next_discount_level?.min_value || "")
            ?.replaceAll("{{ next_max_value }}", next_discount_level?.max_value || "");
    },

    get next_discount_message() {
        const current_discount_levels = this.current_discount_levels;
        if (!current_discount_levels) {
            return "";
        }

        if (!current_discount_levels?.length) {
            return "";
        }

        const frequency = this.frequency;
        if (!frequency) {
            return "";
        }

        const discount_level = this.next_discount_level;
        if (!discount_level) {
            return "";
        }

        let message;
        if (this.default_quantity === 0 || this.cart_total_lashes_quantity > 0) {
            message = discount_level?.messages?.next;
        } else {
            message = discount_level?.messages?.current;
        }

        if (!message) {
            return "";
        }

        const next_discount_level = current_discount_levels[this.next_discount_level_index + 1] || current_discount_levels[current_discount_levels.length - 1] || null;

        return message?.replaceAll(`{{ frequency }}`, frequency)
            ?.replaceAll(`{{ discount }}`, discount_level?.discount)
            ?.replaceAll(`{{ current_discount }}`, discount_level?.discount)
            ?.replaceAll("{{ min_value }}", discount_level?.min_value || "")
            ?.replaceAll("{{ max_value }}", discount_level?.max_value || "")
            ?.replaceAll("{{ next_discount }}", next_discount_level?.discount || "")
            ?.replaceAll("{{ next_min_value }}", next_discount_level?.min_value || "")
            ?.replaceAll("{{ next_max_value }}", next_discount_level?.max_value || "");
    },
};
